import { gql } from '@apollo/client';

export const SUBSCRIBE_DB_EVENT = gql`
  subscription db_event(
    $eb_organization_id: String!
    $eb_location_id: String!
    $area: String!
  ) {
    events(
      limit: 1
      order_by: { event_id: desc }
      where: {
        eb_organization_id: { _like: $eb_organization_id }
        eb_location_id: { _like: $eb_location_id }
        area: { _ilike: $area }
      }
    ) {
      event_id
      type
      ts
      session_id
      area
    }
  }
`;
